// extracted by mini-css-extract-plugin
export default {"tableContainer":"index_tableContainer__D65WC"};